import { useTranslation } from "react-i18next";
import SectionDivider from "../../../components/SectionDivider";
import { toMoney } from "../../../utils/toMoney";
import { formatDate } from "../../../utils/toDate";
import TextDiv from "../../../components/TextDiv";

export default function NoCustomerInvoiceDetails({ invoice }) {
  const { t } = useTranslation("general");

  return (
    <div className="add-shipped-container-invoice-part">
      <SectionDivider title="invoiceDetails" />
      <TextDiv
        title={"invoiceNumber"}
        value={invoice?.invoiceNumber}
        divClasses="item-invoice-div"
        spanClasses="u-flex_flex-2 t-bold_bold"
        pClasses="t-bold_normal u-width-specific_150"
      />
      <TextDiv
        title={"Date"}
        value={formatDate(invoice?.date)}
        divClasses="item-invoice-div"
        spanClasses="u-flex_flex-2 t-bold_bold"
        pClasses="t-bold_normal u-width-specific_150"
      />
      <TextDiv
        title={"amountInSupplierCurrency"}
        value={`${toMoney(invoice?.amountForSupplier)} ${
          invoice?.supplier?.currency
        }`}
        divClasses="item-invoice-div"
        spanClasses="u-flex_flex-2 t-bold_bold"
        pClasses="t-bold_normal u-width-specific_150"
      />

      <TextDiv
        title={"createdAt"}
        value={formatDate(invoice?.createdAt)}
        divClasses="item-invoice-div"
        spanClasses="u-flex_flex-2 t-bold_bold"
        pClasses="t-bold_normal u-width-specific_150"
      />

      <TextDiv
        title={"notes"}
        value={invoice?.notes}
        divClasses="item-invoice-div"
        spanClasses="u-flex_flex-2 t-bold_bold"
        pClasses="t-bold_normal u-width-specific_150"
      />
    </div>
  );
}
